import PageHeader from 'components/pageHeader/PageHeader';
import useSidePanel from 'components/sidePanel/useSidePanel';
import { channelsTabSidePanelId } from 'pages/channels/ChannelsTabs.constants';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import useIsMobileScreen from 'hooks/useIsMobileScreen';
import { MenuButtonStyled } from './TabHeader.styles';

const CHANNEL_MANAGEMENT_DOC_LINK =
  'https://help.hostfully.com/en/collections/113501-channel-management';

const TabHeader = ({ title }: { title: string }) => {
  const isMobile = useIsMobileScreen();
  const { triggerClassName, toggleSidePanel } = useSidePanel({
    sidePanelId: channelsTabSidePanelId,
  });

  return (
    <div>
      <PageHeader
        title={
          <>
            {isMobile && (
              <MenuButtonStyled
                data-testid="settings-tab-hamburger-menu"
                onClick={toggleSidePanel}
                className={triggerClassName}
                bsStyle="default"
              >
                <Glyphicon glyph="menu-hamburger" />
              </MenuButtonStyled>
            )}

            {title}
          </>
        }
        subtitle={
          <Trans
            i18nKey="pageChannels.tabHeaderDescription"
            components={{
              1: <Link to={CHANNEL_MANAGEMENT_DOC_LINK} target="_blank" />,
            }}
          />
        }
      />
    </div>
  );
};

export default TabHeader;
